import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
      font-family:  sans-serif;

}
`;

export const Theme = {
  colors: {
    bgcolor: "#292F3E",
    primarycolor: "#E4E4E4",
    secondarycolor: "#82ABE1",
    colorgreen: "#82E185",
    error: "#E18285",
    line: "#484C56",
    border: "#586F93",
    fontdarken: "#adb6c4",
  },
};

export default GlobalStyle;
